import  { Injectable } from '@angular/core';
import { environment } from '@app/config/environment';
import { ConstantsService } from '@app/core/services/constants.service';
import { SocoConfigurationService } from '@app/base/soco';

import moment from "moment";

/* istanbul ignore next */
@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  constructor(private constants: ConstantsService, private config: SocoConfigurationService) { }

  public get isSoCoProduction(): boolean { return (environment.environment.toLowerCase() === 'spr'); } // Todo: DSS: SPR longer valid according to latest list from Sunil - BT 3/22/24
  public get isSoCoEnv(): boolean { return (environment.environment.toLowerCase() === 'spr'); } // Todo: DSS: SPR longer valid according to latest list from Sunil - BT 3/22/24
  public get isProduction(): boolean { return environment.production; }
  public get appAOT(): string { return (environment.production ? 'AOT' : 'N-AOT'); }
  public get appEnvironmentName(): string { return environment.environment.toUpperCase(); }
  public get appVersion(): string { return environment.version; }
  public get appUrl(): string { return this.isSoCoEnv ? '/' : this.constants.localIISBaseUrl; }
  public get appCopyrightYear(): number { return moment().year(); }
  public get isBuilderEnabled(): boolean { return environment.isBuilderEnabled; }
  public get gisURL(): string { return this.config.gisUrl; }
  public get showAddSubsidiary(): boolean { return environment.showAddSubsidiary; }
  public get showPayment(): boolean { return environment.showPayment; }
  public get gisBaseURL(): string { return this.config.gisBaseUrl; }
  public get builderFirstURL(): string { return this.config.builderFirstUrl; }
}
